import { NestedOption } from '~/core/shared/types/utility';
import { resolveNestedOptionBranch } from './resolveNestedOptionBranch';

export const isNestedOptionLeafPath = (
  options: readonly NestedOption[],
  path: string | null | undefined,
): boolean => resolveNestedOptionBranch(options, path) !== null;
